import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { parseWhatsAppText } from '../../../utils/formatWhatsAppText';
import useMessageStyles from '../../../hooks/useMessageStyles';

function renderSegment(segment, index) {
  switch (segment.type) {
    case 'bold':
      return (
        <Box key={index} component="strong" sx={{ fontWeight: 700, color: 'inherit' }}>
          {segment.value}
        </Box>
      );
    case 'italic':
      return (
        <Box key={index} component="em" sx={{ color: 'inherit' }}>
          {segment.value}
        </Box>
      );
    case 'strike':
      return (
        <Box key={index} component="s" sx={{ color: 'inherit' }}>
          {segment.value}
        </Box>
      );
    case 'code':
      return (
        <Box
          key={index}
          component="code"
          sx={{
            fontFamily: 'monospace',
            fontSize: '0.92em',
            px: 0.5,
            borderRadius: 0.5,
            bgcolor: 'action.hover',
            color: 'inherit',
          }}
        >
          {segment.value}
        </Box>
      );
    case 'link':
      return (
        <Link
          key={index}
          href={segment.value}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{ color: 'inherit', fontWeight: 500 }}
        >
          {segment.value}
        </Link>
      );
    case 'break':
      return <br key={index} />;
    default:
      return <React.Fragment key={index}>{segment.value}</React.Fragment>;
  }
}

export default function FormattedText({ text, variant = 'body2', sx = {} }) {
  const { messageBodyTextSx } = useMessageStyles();

  if (!text) return null;

  const segments = parseWhatsAppText(text);

  return (
    <Typography
      variant={variant}
      component="div"
      sx={{
        ...messageBodyTextSx,
        ...sx,
      }}
    >
      {segments.map(renderSegment)}
    </Typography>
  );
}
